module.exports = __webpack_public_path__ + "static/media/Utrecht.59f80c0e.jpg";